export const apiUrl = "https://worldquizbackend.herokuapp.com";
